import axios from "@/plugins/axios";

export default {
  getImage(id) {
    return axios.get(`/supplier_images/${id}`);
  },
  getImageList(supplier_id) {
    return axios.get(`/suppliers/${supplier_id}/images`);
  },

  addImage(supplier_id, { description, key }) {
    return axios.post(`/suppliers/${supplier_id}/images`, { description, key });
  },
  updateImage(id, { description, description_cache, dependent_id }) {
    // Note: CANNOT replace actual image
    return axios.post(`/supplier_images/${id}`, {
      description,
      description_cache,
      supplier_id: dependent_id,
    });
  },
  saveDefaultImages(imageList) {
    return axios.post("/supplier_image_defaults", {
      images: imageList,
    });
  },
  deleteImage(id) {
    return axios.delete(`/supplier_images/${id}`);
  },
  deleteImageList(idList) {
    return axios.delete("/supplier_images", {
      data: { image_list: idList },
    });
  },
};
